'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _prefix = require('../prefix');

var _prefix2 = _interopRequireDefault(_prefix);

var _pascalize = require('../utils/pascalize');

var _pascalize2 = _interopRequireDefault(_pascalize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

// Support old break-* props syntax.
// https://caniuse.com/#search=multicolumn
// https://github.com/postcss/autoprefixer/issues/491
// https://github.com/postcss/autoprefixer/issues/177
exports['default'] = {
  supportedProperty: function supportedProperty(prop, style) {
    if (!/^break-/.test(prop)) return false;
    if (_prefix2['default'].js === 'Webkit') {
      var jsProp = 'WebkitColumn' + (0, _pascalize2['default'])(prop);
      return jsProp in style ? _prefix2['default'].css + 'column-' + prop : false;
    }
    if (_prefix2['default'].js === 'Moz') {
      var _jsProp = 'page' + (0, _pascalize2['default'])(prop);
      return _jsProp in style ? 'page-' + prop : false;
    }
    return false;
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/css-vendor/lib/plugins/break-props-old.js
// module id = 8
// module chunks = 0